import React from "react";

const TabSwitcher = ({ tabs = [], activeTab, onTabChange }) => {
  return (
    <ul className="flex flex-row border-b gap-2">
      {tabs.map((tab) => (
        <li key={tab.key}>
          <button
            onClick={() => onTabChange(tab.key)}
            className={`px-4 py-2 rounded-t-md text-sm font-medium border-b-2 transition-all duration-200 ${
              activeTab === tab.key
                ? "border-primary text-primary bg-white"
                : "border-transparent text-gray-500 hover:text-primary"
            }`}
          >
            {tab.label}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default TabSwitcher;
